import { render, staticRenderFns } from "./stepsRule.vue?vue&type=template&id=2d1a273d"
import script from "./stepsRule.vue?vue&type=script&lang=js"
export * from "./stepsRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports